import { isAuthenticated, auth0Client, username, email, userLocation } from './stores.js';
import { get } from 'svelte/store';
import { toast } from '@zerodevx/svelte-toast';
import { toastThemeError } from './toasts.js';
import * as Sentry from "@sentry/svelte";

// BEGIN Auth0
import { createAuth0Client } from '@auth0/auth0-spa-js';
import { authClientParameters } from './configurations/auth0.js';
export let user;

async function authenticate(client) {
    user = await client.getUser();
    console.log('USER:', user);
    if ( user === undefined) {
        isAuthenticated.set(false);
        throw Error("Login required");
    }
    username.set(user.nickname || user.name);
    email.set(user.email || user.name);

    try {
        const claims = await client.getIdTokenClaims();
        const id_token = claims.__raw;
        console.log(claims);
        if (claims) {
            userLocation.set(claims['https://exciscope.com/country']);
        }
    }
    catch {
        isAuthenticated.set(false);
        throw Error("Login required");
    }
    isAuthenticated.set(true);
    // if you need the raw id_token, you can access it
    // using the __raw property

    // Set tag for Sentry tracing
    try {
        const language = navigator.language;
        const country = user["https://exciscope.com/country"];
        const timezone = user["https://exciscope.com/timezone"];
        if (language) Sentry.setTag("browser_language", language);
        if (country) Sentry.setTag("auth_country", country);
        if (timezone) Sentry.setTag("auth_timezone", timezone);
    } catch (e) {
        console.log('SENTRY TAGS COULD NOT BE SET: ', e);
    }
}

export async function getAccessToken() {
    if (!get(isAuthenticated)) return;
    
    // Get a JWT access token from the auth client
    const client = get(auth0Client);
    const accessToken = await client.getTokenSilently();

    return accessToken;
}

export async function initAuthClient(environment) {
    if (get(isAuthenticated)) return;
    const urlSearchParams = new URLSearchParams(window.location.search);

    console.log('INITIALISING AUTH0 CLIENT...');
    let auth0ClientPromise;
    if(environment === 'prod') {
        auth0ClientPromise = await createAuth0Client(authClientParameters.prod);
    }
    else {
        auth0ClientPromise = await createAuth0Client( authClientParameters.dev );
    }
    if (auth0ClientPromise) {
        auth0Client.set(auth0ClientPromise);
    }
    if (urlSearchParams.get('code')) {
        try {
            await auth0ClientPromise.handleRedirectCallback();
        }
        catch (e) {
            const msg = `Login fail: ${e.message}`;
            console.log(msg);
            toast.push(msg, toastThemeError);
        }

        let fragment = "/";
        if(window.location.href.includes("#")) {
            fragment = "/#" + window.location.href.split("#")[1];
            console.log("#"+fragment);
        }

        window.history.replaceState({}, document.title, fragment );
        authenticate(auth0ClientPromise);
    }
    else {
        try {
            await authenticate(auth0ClientPromise);
        }
        catch (e) {
            const msg = `Login fail: ${e.message}`;
            console.log(e);
            toast.push(msg, toastThemeError);
        }
    }
    console.log('DONE INITIALISING AUTH0 CLIENT!');
    console.log('$isAuthenticated=', get(isAuthenticated));
    console.log(get(auth0Client));
}

export async function login(options) {
    console.log('LOGIN CALLED... ', options);
    if (!get(auth0Client)) {
        console.log('AUTH0CLIENT=', get(auth0Client));
        return;
    }
    try {
        const $auth0Client = get(auth0Client);
        await $auth0Client.loginWithRedirect();

    } catch (loginError) {
        console.log('LOGIN ERROR!!!');
        console.error(loginError);
    }
}

export function logout() {
    console.log('LOGOUT CALLED...');
    const $auth0Client = get(auth0Client);
    const logoutResponse = $auth0Client.logout({logoutParams: {returnTo: window.location}});
    isAuthenticated.set(false);
    username.set(undefined);
    email.set(undefined);
    userLocation.set(undefined);
    return logoutResponse;
}

// END Auth0